import { useEffect, useState } from 'react';

import MatAvatar from '@mui/material/Avatar';
import { Box, Skeleton } from '@mui/material';
import { useGetImageUrl } from 'app/hooks/useGetImageUrl';

const Avatar = ({ path, type, src, size, ...props }) => {
  const fetchImage = useGetImageUrl(type, path);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(!src && Boolean(path && type));

  useEffect(() => {
    if (src) {
      setLoading(false);
      setImageUrl(null);
      return;
    }

    if (!path || !type) {
      setLoading(false);
      setImageUrl(null);
      return;
    }

    let isActive = true;
    setLoading(true);

    fetchImage()
      .then((url) => {
        if (isActive) {
          setImageUrl(url);
        }
      })
      .catch(() => {
        if (isActive) {
          setImageUrl(null);
        }
      })
      .finally(() => {
        if (isActive) {
          setLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [fetchImage, path, src, type]);

  return (
    <Box sx={{ height: size, width: size }}>
      {loading ? (
        <Skeleton variant="circular" width={size} height={size} />
      ) : (
        <MatAvatar sx={{ height: size, width: size }} src={src || imageUrl} {...props} />
      )}
    </Box>
  );
};

export default Avatar;
